/* tslint:disable */
/* eslint-disable */
/**
 * Joule Conductor Cloud
 * This specification document describes the Joule Technologies Application Programming Interface  (API). The endpoints, message formats and status codes are explained in this document. ## Communication  ### Base URI  The base Uniform Resource Identifier (URI) is: https://user-api.joule-cloud.com/v2 This URI is the prefix for all endpoints described in this document. ### Body format  The endpoints of the API expecting a body must be in JavaScript Object Notation (JSON) format.  Response bodies from the endpoints also adhere to this standard, unless otherwise stated.  Responses will include a Content-Type header indicating the ‘application/json’ type. An invalid  or missing body will result in a 400-status code accompanied by an error code to specify the  nature of the error. ### Security The API uses HTTPS as the underlying protocol to transfer data. The server hosts a certificate  to set up a secure connection using Transport Layer Security (TLS) version 1.2. The authenticity  of the server certificate is verifiable by the client using publicly available sources.  #### Authentication and authorization  The API should only be called by legitimate users with the correct access rights. The API uses  the Open Authorization 2.0 (OAuth) standard to achieve this. Every request to the API should  include a bearer access token in the JSON Web Token (JWT) format in the Authorization header.  The header should be formatted such as in the example below.  ```   {“Authorization”: “Bearer <JWT>”}  ``` The JWT must be acquired from one of the following identity providers:   * joule-technologies.eu.auth0.com    * inventum-app.eu.auth0.com    * joule-app.eu.auth0.com   For help regarding gaining an access token you can find the docs for Auth0  [here](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). The JWT must be intended for one of the following audiences:    * https://user-api.joule-cloud.com   If the authorization header does not match the requirements stated above the API will respond  with a 401-status code accompanied by an error code to specify the nature of the error.  ### Timeout The API specifies a maximum amount of time between a request and the response to avoid blocking  either side. The general timeout that has been set for each endpoint is 3000 milliseconds.  This timeout is used unless otherwise stated in the respective endpoint documentation.  If the server is unable to respond within this maximum time, the response contains a 504-status  code. The client may retry the request. The time out for a stream to be open is 1800 seconds.  If the stream is still open passed the experitation the server will close the stream. ### Rate limits  No rate limit is currently imposed. ### Diagnostics response  The diagnostics response provides the caller of the API with more information in case of a  failed request. This information can be used for debugging and recovery/retrying purposes.  The diagnostics response is always included under the “diagnostics” key if the response  has a body. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Diagnostics,
  Faq,
  ParametersV1,
  ParametersV2,
  QuestionsV1,
  QuestionsV2,
  QuestionsV3,
  Settings,
  StoreSettingsRequest,
  TranslationFiles,
} from '../models/index';
import {
    DiagnosticsFromJSON,
    DiagnosticsToJSON,
    FaqFromJSON,
    FaqToJSON,
    ParametersV1FromJSON,
    ParametersV1ToJSON,
    ParametersV2FromJSON,
    ParametersV2ToJSON,
    QuestionsV1FromJSON,
    QuestionsV1ToJSON,
    QuestionsV2FromJSON,
    QuestionsV2ToJSON,
    QuestionsV3FromJSON,
    QuestionsV3ToJSON,
    SettingsFromJSON,
    SettingsToJSON,
    StoreSettingsRequestFromJSON,
    StoreSettingsRequestToJSON,
    TranslationFilesFromJSON,
    TranslationFilesToJSON,
} from '../models/index';

export interface LoadSettingsRequest {
    serialNumber: string;
}

export interface StoreSettingsOperationRequest {
    serialNumber: string;
    installSettings: StoreSettingsRequest;
}

export interface TechnicianGetParametersV1Request {
    deviceType: string;
}

export interface TechnicianGetParametersV2Request {
    deviceType: string;
}

/**
 * 
 */
export class TechnicianApi extends runtime.BaseAPI {

    /**
     * Creates request options for loadSettings without sending the request
     */
    async loadSettingsRequestOpts(requestParameters: LoadSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serialNumber'] == null) {
            throw new runtime.RequiredError(
                'serialNumber',
                'Required parameter "serialNumber" was null or undefined when calling loadSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/technician/devices/{serialNumber}/settings`;
        urlPath = urlPath.replace(`{${"serialNumber"}}`, encodeURIComponent(String(requestParameters['serialNumber'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * This endpoint is used to load the set-up parameters of a device
     */
    async loadSettingsRaw(requestParameters: LoadSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Settings>> {
        const requestOptions = await this.loadSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SettingsFromJSON(jsonValue));
    }

    /**
     * This endpoint is used to load the set-up parameters of a device
     */
    async loadSettings(requestParameters: LoadSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Settings> {
        const response = await this.loadSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for storeSettings without sending the request
     */
    async storeSettingsRequestOpts(requestParameters: StoreSettingsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serialNumber'] == null) {
            throw new runtime.RequiredError(
                'serialNumber',
                'Required parameter "serialNumber" was null or undefined when calling storeSettings().'
            );
        }

        if (requestParameters['installSettings'] == null) {
            throw new runtime.RequiredError(
                'installSettings',
                'Required parameter "installSettings" was null or undefined when calling storeSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/technician/devices/{serialNumber}/settings`;
        urlPath = urlPath.replace(`{${"serialNumber"}}`, encodeURIComponent(String(requestParameters['serialNumber'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StoreSettingsRequestToJSON(requestParameters['installSettings']),
        };
    }

    /**
     * This endpoint is used to store the set-up parameters of a device
     */
    async storeSettingsRaw(requestParameters: StoreSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.storeSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This endpoint is used to store the set-up parameters of a device
     */
    async storeSettings(requestParameters: StoreSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeSettingsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for technicianGetFaq without sending the request
     */
    async technicianGetFaqRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/technician/faq`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get faq used in the installer app
     */
    async technicianGetFaqRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Faq>> {
        const requestOptions = await this.technicianGetFaqRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FaqFromJSON(jsonValue));
    }

    /**
     * Get faq used in the installer app
     */
    async technicianGetFaq(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Faq> {
        const response = await this.technicianGetFaqRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for technicianGetParametersV1 without sending the request
     */
    async technicianGetParametersV1RequestOpts(requestParameters: TechnicianGetParametersV1Request): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceType'] == null) {
            throw new runtime.RequiredError(
                'deviceType',
                'Required parameter "deviceType" was null or undefined when calling technicianGetParametersV1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/technician/parameters/{deviceType}`;
        urlPath = urlPath.replace(`{${"deviceType"}}`, encodeURIComponent(String(requestParameters['deviceType'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get parameters used in the installer app
     */
    async technicianGetParametersV1Raw(requestParameters: TechnicianGetParametersV1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParametersV1>> {
        const requestOptions = await this.technicianGetParametersV1RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParametersV1FromJSON(jsonValue));
    }

    /**
     * Get parameters used in the installer app
     */
    async technicianGetParametersV1(requestParameters: TechnicianGetParametersV1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParametersV1> {
        const response = await this.technicianGetParametersV1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for technicianGetParametersV2 without sending the request
     */
    async technicianGetParametersV2RequestOpts(requestParameters: TechnicianGetParametersV2Request): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceType'] == null) {
            throw new runtime.RequiredError(
                'deviceType',
                'Required parameter "deviceType" was null or undefined when calling technicianGetParametersV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/technician-v2/parameters/{deviceType}`;
        urlPath = urlPath.replace(`{${"deviceType"}}`, encodeURIComponent(String(requestParameters['deviceType'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get parameters used in the installer app
     */
    async technicianGetParametersV2Raw(requestParameters: TechnicianGetParametersV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParametersV2>> {
        const requestOptions = await this.technicianGetParametersV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParametersV2FromJSON(jsonValue));
    }

    /**
     * Get parameters used in the installer app
     */
    async technicianGetParametersV2(requestParameters: TechnicianGetParametersV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParametersV2> {
        const response = await this.technicianGetParametersV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for technicianGetQuestionsV1 without sending the request
     */
    async technicianGetQuestionsV1RequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/technician/questions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get questions used in the installer app questionnaire
     */
    async technicianGetQuestionsV1Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestionsV1>> {
        const requestOptions = await this.technicianGetQuestionsV1RequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestionsV1FromJSON(jsonValue));
    }

    /**
     * Get questions used in the installer app questionnaire
     */
    async technicianGetQuestionsV1(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestionsV1> {
        const response = await this.technicianGetQuestionsV1Raw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for technicianGetQuestionsV2 without sending the request
     */
    async technicianGetQuestionsV2RequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/technician-v2/questions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get questions used in the installer app questionnaire
     */
    async technicianGetQuestionsV2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestionsV2>> {
        const requestOptions = await this.technicianGetQuestionsV2RequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestionsV2FromJSON(jsonValue));
    }

    /**
     * Get questions used in the installer app questionnaire
     */
    async technicianGetQuestionsV2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestionsV2> {
        const response = await this.technicianGetQuestionsV2Raw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for technicianGetQuestionsV3 without sending the request
     */
    async technicianGetQuestionsV3RequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/technician-v3/questions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get questions used in the installer app questionnaire
     */
    async technicianGetQuestionsV3Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestionsV3>> {
        const requestOptions = await this.technicianGetQuestionsV3RequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestionsV3FromJSON(jsonValue));
    }

    /**
     * Get questions used in the installer app questionnaire
     */
    async technicianGetQuestionsV3(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestionsV3> {
        const response = await this.technicianGetQuestionsV3Raw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for technicianGetTranslationsV1 without sending the request
     */
    async technicianGetTranslationsV1RequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/technician/translations`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get translations for the installer app
     */
    async technicianGetTranslationsV1Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TranslationFiles>> {
        const requestOptions = await this.technicianGetTranslationsV1RequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TranslationFilesFromJSON(jsonValue));
    }

    /**
     * Get translations for the installer app
     */
    async technicianGetTranslationsV1(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TranslationFiles> {
        const response = await this.technicianGetTranslationsV1Raw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for technicianGetTranslationsV2 without sending the request
     */
    async technicianGetTranslationsV2RequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/technician-v2/translations`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get translations for the installer app
     */
    async technicianGetTranslationsV2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TranslationFiles>> {
        const requestOptions = await this.technicianGetTranslationsV2RequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TranslationFilesFromJSON(jsonValue));
    }

    /**
     * Get translations for the installer app
     */
    async technicianGetTranslationsV2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TranslationFiles> {
        const response = await this.technicianGetTranslationsV2Raw(initOverrides);
        return await response.value();
    }

}
